onComplete(() => {
	// Het embleem op de herofoto heeft een vaste plek rechtsonder en loopt bij
	// hover achter de cursor aan. De verschuiving gaat als variabele naar het
	// item, omdat het embleem zelf een pseudo-element is.
	const badgeTraagheid = 0.07;

	document.querySelectorAll('.header .blog-item-preview').forEach(function (item, index) {
		// Het opschrift volgt waar het item naartoe wijst.
		const doelLink = item.querySelector('a[href]');
		const naarVacature = doelLink && doelLink.getAttribute('href').indexOf('werken-bij') !== -1;
		const opschrift = naarVacature ? 'Bekijk de vacature' : 'Bekijk het project';
		const padId = 'hero-badge-pad-' + index;

		const embleem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		embleem.setAttribute('class', 'hero-badge');
		embleem.setAttribute('viewBox', '0 0 127 127');
		embleem.setAttribute('aria-hidden', 'true');
		embleem.setAttribute('focusable', 'false');
		embleem.innerHTML =
			'<circle class="hero-badge-vlak" cx="63.5" cy="63.5" r="48.5"></circle>' +
			'<path id="' + padId + '" fill="none" d="M63.5 63.5m-35 0a35 35 0 1 1 70 0a35 35 0 1 1-70 0"></path>' +
			'<text class="hero-badge-tekst"><textPath href="#' + padId + '" startOffset="25%" text-anchor="middle">' +
			opschrift +
			'</textPath></text>';
		item.appendChild(embleem);

		let doelX = 0;
		let doelY = 0;
		let huidigX = 0;
		let huidigY = 0;
		let loopt = false;

		const stap = function () {
			// Per beeld een klein deel van de resterende afstand, zodat het embleem
			// zichtbaar naloopt in plaats van aan de cursor vast te zitten.
			huidigX += (doelX - huidigX) * badgeTraagheid;
			huidigY += (doelY - huidigY) * badgeTraagheid;

			item.style.setProperty('--badge-x', huidigX.toFixed(1) + 'px');
			item.style.setProperty('--badge-y', huidigY.toFixed(1) + 'px');

			if (Math.abs(doelX - huidigX) < 0.5 && Math.abs(doelY - huidigY) < 0.5) {
				loopt = false;
				return;
			}

			requestAnimationFrame(stap);
		};

		const start = function () {
			if (!loopt) {
				loopt = true;
				requestAnimationFrame(stap);
			}
		};

		item.addEventListener('mousemove', function (event) {
			const vlak = item.getBoundingClientRect();
			const stijl = getComputedStyle(embleem);

			// Middelpunt van de rustplek, gemeten vanaf de rechteronderhoek.
			const rustX = vlak.width - parseFloat(stijl.right) - parseFloat(stijl.width) / 2;
			const rustY = vlak.height - parseFloat(stijl.bottom) - parseFloat(stijl.height) / 2;

			doelX = event.clientX - vlak.left - rustX;
			doelY = event.clientY - vlak.top - rustY;
			start();
		});

		item.addEventListener('mouseleave', function () {
			doelX = 0;
			doelY = 0;
			start();
		});
	});

	// Links zonder eigen tekst omsluiten een logo, icoon of foto; die krijgen geen
	// tekstmarkering.
	document.querySelectorAll('a').forEach(function (link) {
		if (!link.textContent.trim()) {
			link.classList.add('is-visual-link');
		}
	});

	// Zonder kopfoto laat het kopblok van een overzicht alleen lege ruimte achter.
	// In de editor blijft het staan, anders is er geen plek om een foto te zetten.
	if (!document.body.hasAttribute('data-editor-mode')) {
		document.querySelectorAll('.blog-collection > .header').forEach(function (kopBlok) {
			if (kopBlok.querySelector('.image-empty')) {
				kopBlok.hidden = true;
			}
		});
	}

	// De sizes van een previewfoto gaan uit van een halve schermbreedte, maar in
	// deze feeds is de foto op mobiel bijna schermvullend en op desktop juist een
	// smalle kolom. Daardoor kiest de browser op mobiel een veel te klein bestand
	// en op desktop een onnodig groot. De werkelijke kolombreedte zet dat recht.
	const stelSizesIn = function () {
		document.querySelectorAll('.blog-item-preview picture').forEach(function (plaatje) {
			const foto = plaatje.querySelector('img');
			const breedte = foto && Math.round(foto.getBoundingClientRect().width);

			// Een foto die nog niet in beeld staat heeft geen breedte; die houdt zijn
			// oorspronkelijke sizes tot hij wel te meten is.
			if (!breedte) {
				return;
			}

			const sizes = breedte + 'px';
			plaatje.querySelectorAll('source').forEach(function (bron) {
				bron.sizes = sizes;
			});
			foto.sizes = sizes;
		});
	};

	let hermeten;
	stelSizesIn();

	window.addEventListener('resize', function () {
		clearTimeout(hermeten);
		hermeten = setTimeout(stelSizesIn, 200);
	});

	if (window.editor) {
		window.editor.addEventListener('reloaded', stelSizesIn);
	}

	// Mobiel uitklapmenu. Het paneel verhuist naar de body, omdat de pagina zelf
	// verschoven wordt en een paneel binnen die pagina gewoon mee zou schuiven.
	// De hamburger staat in de balk onderin en niet in de header, dus hij wordt
	// gevonden via het paneel dat hij opent.
	const menuKnop = document.querySelector('.navbar-toggler[data-target="#navbar-supported-content"]');
	const menuPaneel = menuKnop && document.querySelector(menuKnop.getAttribute('data-target'));

	if (menuPaneel) {
		menuPaneel.classList.add('nav-drawer');
		document.body.appendChild(menuPaneel);

		// Zonder deze instelling positioneert Bootstrap het submenu zwevend boven
		// het paneel; in de menustroom hoort het gewoon mee te schuiven.
		menuPaneel.querySelectorAll('[data-toggle="dropdown"]').forEach(function (knop) {
			knop.setAttribute('data-display', 'static');
		});

		const sluier = document.createElement('div');
		sluier.className = 'nav-drawer-overlay';
		document.body.appendChild(sluier);

		// De hamburgerknop schuift met de pagina uit beeld, dus het paneel krijgt
		// een eigen sluitknop.
		const sluitKnop = document.createElement('button');
		sluitKnop.className = 'nav-drawer-close';
		sluitKnop.type = 'button';
		sluitKnop.textContent = menuKnop.getAttribute('data-label-close') || 'Menu sluiten';
		document.body.appendChild(sluitKnop);

		let scrollPositie = 0;

		const toon = function (open) {
			if (open) {
				scrollPositie = window.scrollY;
				document.documentElement.style.setProperty('--menu-scroll', scrollPositie + 'px');
			}

			document.documentElement.classList.toggle('menu-open', open);
			sluier.classList.toggle('is-visible', open);
			sluitKnop.classList.toggle('is-visible', open);

			if (!open) {
				// Het losmaken van de pagina brengt het document terug naar boven;
				// de oude positie gaat er zonder scrollanimatie weer op.
				const soepelScrollen = document.documentElement.style.scrollBehavior;
				document.documentElement.style.scrollBehavior = 'auto';
				window.scrollTo(0, scrollPositie);
				document.documentElement.style.scrollBehavior = soepelScrollen;
			}
		};

		const sluitMenu = function () {
			if (menuKnop.getAttribute('aria-expanded') === 'true') {
				menuKnop.click();
			}
		};

		if (window.jQuery) {
			window.jQuery(menuPaneel)
				.on('show.bs.collapse', function () {
					toon(true);
				})
				.on('hide.bs.collapse', function () {
					toon(false);
				});
		}

		sluier.addEventListener('click', sluitMenu);
		sluitKnop.addEventListener('click', sluitMenu);

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') {
				sluitMenu();
			}
		});
	}
});
